import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import * as mediaQuery from "components/MediaQuery";

export const Row = styled.div<{ status?: boolean }>`
  ${FLEX.FlexStartCenter};
  gap: 8px;

  ${({ status }) =>
    status &&
    `
    color: ${COLORS.SELECTED}
  `}
`;

export const DisplayAlert = styled.div`
  ${FLEX.FlexStartStart};
  flex-wrap: wrap;
  column-gap: 4px;
  ${mediaQuery.isDesktop} {
    span {
      white-space: normal;
      word-break: break-all;
      line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      word-break: break-word;
      white-space: normal;
    }
  }
`;

export const StatusTxt = styled.div<{ string: string }>`
  color: #828b9b;
  ${({ string }) =>
    string === "ACTIVE" &&
    `
    color: ${COLORS.PROGRESSBAR};
  `};
  ${({ string }) =>
    string === "ASSIGNED" &&
    `
    color: ${COLORS.BUTTONS2};
  `};
`;

export const SubTitleWrapper = styled.div`
  ${FLEX.FlexStartEnd};
  gap: 7px;
`;

export const Label = styled.label`
  ${FLEX.FlexStartCenter};
  align-items: flex-end;
  gap: 4px;

  > img {
    height: 15px;
  }
`;
